import _defaultTo from 'lodash/defaultTo';
import _size from 'lodash/size';
import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_DEVICE_BATCHES,
  GET_DEVICE_BATCHES_SUCCESS,
  GET_DEVICE_BATCHES_ERROR,
  ADD_DEVICE_BATCH,
  ADD_DEVICE_BATCH_SUCCESS,
  ADD_DEVICE_BATCH_ERROR,
  GET_DEVICE_BATCH,
  GET_DEVICE_BATCH_SUCCESS,
  GET_DEVICE_BATCH_ERROR,
  UPDATE_DEVICE_BATCH,
  UPDATE_DEVICE_BATCH_SUCCESS,
  UPDATE_DEVICE_BATCH_ERROR,
  GET_DEVICE_BATCH_AUTHOR,
  GET_DEVICE_BATCH_AUTHOR_SUCCESS,
  GET_DEVICE_BATCH_AUTHOR_ERROR,
  GET_DEVICE_BATCH_COMMITTER,
  GET_DEVICE_BATCH_COMMITTER_SUCCESS,
  GET_DEVICE_BATCH_COMMITTER_ERROR,
  GET_DEVICE_BATCH_DISTRIBUTION,
  GET_DEVICE_BATCH_DISTRIBUTION_SUCCESS,
  GET_DEVICE_BATCH_DISTRIBUTION_ERROR,
  GET_DEVICE_BATCH_ARCHIVE,
  GET_DEVICE_BATCH_ARCHIVE_SUCCESS,
  GET_DEVICE_BATCH_ARCHIVE_ERROR,
} from '../../constants/ActionTypes';
// Model
/* eslint-disable import/named */
import { deserialize, deserializeUser, sortElements } from '../../models/deviceBatch';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.deviceBatch;
const company = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullDeviceBatch') {
        return {
          ...state,
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
        };
      }
      switch (action.target) {
        case 'currentDeviceBatch':
          key = 'current';
          break;
        case 'addDeviceBatch':
          key = 'add';
          break;
        case 'updateDeviceBatch':
          key = 'update';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // GET DEVICE_BATCHES
    case GET_DEVICE_BATCHES:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case GET_DEVICE_BATCHES_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case GET_DEVICE_BATCHES_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: {
            data: sortElements(deserialize(action.data.data)),
            totalEntries: _size(action.data.data),
          },
          loading: false,
        },
      };
    // ADD DEVICE_BATCH
    case ADD_DEVICE_BATCH:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
        },
      };
    case ADD_DEVICE_BATCH_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case ADD_DEVICE_BATCH_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };
    // GET DEVICE_BATCH
    case GET_DEVICE_BATCH:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_DEVICE_BATCH_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_DEVICE_BATCH_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // UPDATE DEVICE_BATCH
    case UPDATE_DEVICE_BATCH:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          loading: true,
          error: null,
        },
      };
    case UPDATE_DEVICE_BATCH_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
          error: action.error,
        },
      };
    case UPDATE_DEVICE_BATCH_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
          committedDevices: _defaultTo(action.data.data.committed_devices, 0),
          deletedDevices: _defaultTo(action.data.data.deleted_devices, 0),
          updated: true,
        },
      };
    // GET DEVICE_BATCH AUTHOR
    case GET_DEVICE_BATCH_AUTHOR:
      return {
        ...state,
        current: {
          ...state.current,
          data: state.current.data ? {
            ...state.current.data,
            author: {
              data: null,
              loading: true,
            },
          } : null,
        },
      };
    case GET_DEVICE_BATCH_AUTHOR_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          data: (!!state.current.data && state.current.data.id === action.id) ? {
            ...state.current.data,
            author: {
              data: deserializeUser(action.data.data),
              loading: false,
            },
          } : state.current.data,
        },
      };
    case GET_DEVICE_BATCH_AUTHOR_ERROR:
      return state;
    // GET DEVICE_BATCH COMMITER
    case GET_DEVICE_BATCH_COMMITTER:
      return {
        ...state,
        current: {
          ...state.current,
          data: state.current.data ? {
            ...state.current.data,
            committer: {
              data: null,
              loading: true,
            },
          } : null,
        },
      };
    case GET_DEVICE_BATCH_COMMITTER_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          data: (!!state.current.data && state.current.data.id === action.id) ? {
            ...state.current.data,
            committer: {
              data: deserializeUser(action.data.data),
              loading: false,
            },
          } : state.current.data,
        },
      };
    case GET_DEVICE_BATCH_COMMITTER_ERROR:
      return state;
    // GET DEVICE_BATCH DISTRIBUTION
    case GET_DEVICE_BATCH_DISTRIBUTION:
      return {
        ...state,
        current: {
          ...state.current,
          data: state.current.data ? {
            ...state.current.data,
            distributions: {
              ...state.current.data.distributions,
              [action.distribution.type]: {
                loading: true,
              },
            },
          } : null,
        },
      };
    case GET_DEVICE_BATCH_DISTRIBUTION_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          data: (!!state.current.data && state.current.data.id === action.id) ? {
            ...state.current.data,
            distributions: {
              ...state.current.data.distributions,
              [action.data.data.type]: {
                ...action.data.data,
                loading: false,
              },
            },
          } : state.current.data,
        },
      };
    case GET_DEVICE_BATCH_DISTRIBUTION_ERROR:
      return state;
    // GET DEVICE_BATCH ARCHIVE
    case GET_DEVICE_BATCH_ARCHIVE:
      return {
        ...state,
        archive: {
          ...state.archive,
          error: null,
          done: false,
        },
      };
    case GET_DEVICE_BATCH_ARCHIVE_ERROR:
      return {
        ...state,
        archive: {
          ...state.archive,
          error: action.error,
        },
      };
    case GET_DEVICE_BATCH_ARCHIVE_SUCCESS:
      return {
        ...state,
        archive: {
          ...state.archive,
          error: null,
          done: true,
        },
      };
    default:
      return state;
  }
};

export default company;



// WEBPACK FOOTER //
// ./reducers/production/deviceBatch.js